import { DateTimeFormat } from '@billy/design-system'
import { Typography } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import { getCurrentLocale } from '../../../../../../utils/getCurrentLocale'
import { BillsTableRow } from '../../types/billsTableRow'
import { isBillsTableFieldSuggestion } from '../../utils/isBillsTableFieldSuggestion'
import { BillsTableNoDataField } from '../BillsTableNoDataField'
import { BillsTableSuggestedField } from '../BillsTableSuggestedField'

interface BillsTableReceiptDateCellProps {
  row: BillsTableRow
}

export const BillsTableReceiptDateCell = ({ row }: BillsTableReceiptDateCellProps): ReactElement => {
  const locale = getCurrentLocale()

  if (isBillsTableFieldSuggestion(row.receiptDate)) {
    return <BillsTableSuggestedField value={DateTimeFormat.getFormattedDate(row.receiptDate.suggestion, locale)} />
  }

  if (row.receiptDate.actual === null) {
    return <BillsTableNoDataField />
  }

  return <Typography.Text>{DateTimeFormat.getFormattedDate(row.receiptDate.actual, locale)}</Typography.Text>
}
